import React from "react";

import State from "../../../../containers/State";
import { ReactComponent as StateIcon } from "../../../../img/icons/Alajuela.svg";
import { CAMPAIGN_2023 } from '../../../../constants';

const stateName = "Alajuela";
const stateId = "drdqUqE7Bmq76jJH63Go";

const Alajuela = () => {
  return (
    <State stateName={stateName} stateId={stateId} Icon={StateIcon} year="2023" campaign={CAMPAIGN_2023}>
      <StateIcon />
    </State>
  );
};

export default Alajuela;
